module.exports = __webpack_public_path__ + "img/pic_kzht@2x.a04fdcb8.png";